import { faClock } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { createExportButton } from "../../../Grid/ExcelExport/CreateExportButton";
import SingleSelectKendoGrid from "../../../Grid/Selectable/SingleSelectKendoGrid";
import { defaultAddButton } from "../../../Grid/Toolbar/DefaultAddButton";
import { defaultEditButton } from "../../../Grid/Toolbar/DefaultEditButton";
import PageHeader from "../../../Layout/Header/PageHeader";
import { cutOffTimeUrls, rateAgreementUrls } from "../../../URL/ApplicationUrls";
import { combinedUrls } from "../../../URL/functions";
import { RateAgreementOverviewItem } from "../RateAgreementOverviewItem";
import { rateAgreementStateAsString } from "../RateAgreementState/RateAgreementState";
import { RateAgreementGridColumns } from "./RateAgreementGridColumns";
import { AuthorizationPolicies } from "../../../Auth/AuthorizationPolicy";
import { defaultDateFormatDDMMYYYYSeperatedByPeriod, formatDateTo } from "../../../Utils/dates";

export default function RateAgreementsOverview() {
  const navigate = useNavigate();

  const addRateAgreement = () => navigate(rateAgreementUrls.addRateAgreement.uiPath);

  const editRateAgreement = (rateAgreement: RateAgreementOverviewItem | undefined) =>
    rateAgreement && navigate(rateAgreementUrls.uiPathForRateAgreementWithId(rateAgreement.Id));

  const navigateToLtlCutoffTimesButton = {
    text: "LTL Cut-Off Times",
    icon: faClock,
    onClick: (rateAgreement: RateAgreementOverviewItem | undefined) =>
      rateAgreement &&
      navigate({
        pathname: cutOffTimeUrls.forRateAgreement.uiPathFor(rateAgreement.Id),
        search: cutOffTimeUrls.forRateAgreement.searchParams({
          rateAgreementName: rateAgreement.RateAgreementName,
          carrierName: rateAgreement.CarrierName,
        }),
      }),
    disabled: (rateAgreement: RateAgreementOverviewItem | undefined) => !rateAgreement,
  };

  const url = combinedUrls(rateAgreementUrls.base.apiUrl, "KendoGrid");

  return (
    <>
      <PageHeader headerText="Rate Agreement" />
      <SingleSelectKendoGrid
        localStorageKey="RateAgreementOverviewGrid_DataState"
        fetchUrl={url}
        idSelector={(rateAgreement: RateAgreementOverviewItem) => rateAgreement.Id}
        columns={RateAgreementGridColumns()}
        toolbarItems={[
          defaultAddButton({
            onClick: addRateAgreement,
            roles: AuthorizationPolicies.RequireAdminNetworkRoles,
          }),
          defaultEditButton({
            onClick: editRateAgreement,
            roles: AuthorizationPolicies.RequireAdminNetworkRoles,
          }),
          navigateToLtlCutoffTimesButton,
        ]}
        onRowDoubleClick={editRateAgreement}
        customToolbarItems={[
          createExportButton({
            url,
            filename: "RateAgreements",
            mapping: (rateAgreement: RateAgreementOverviewItem) => ({
              ...rateAgreement,
              Status: rateAgreementStateAsString.get(rateAgreement.Status),
              StartDate: formatDateTo(
                rateAgreement.StartDate,
                defaultDateFormatDDMMYYYYSeperatedByPeriod
              ),
              EndDate: formatDateTo(
                rateAgreement.EndDate,
                defaultDateFormatDDMMYYYYSeperatedByPeriod
              ),
            }),
          }),
        ]}
      />
    </>
  );
}
